/**
 * ComparisonTable — ma trận "vai trò nào làm được gì", FR-093.
 *
 * Dùng chung cho hai màn quản trị: *Quản lý quyền người dùng* (vai trò hệ thống)
 * và *Quản lý quyền tên miền* (mức quyền trên từng tên miền). Hai bên nhận cùng
 * hình dạng dữ liệu từ `/roles/matrix` và `/domain-roles/matrix`, nên bảng chỉ
 * cần viết một lần.
 *
 * OQ-247 — **không in mã capability**. `cap.id` vẫn có mặt trong dữ liệu vì bảng
 * cần nó để đối chiếu vai trò nào có quyền nào, nhưng nó là ký hiệu nội bộ của
 * mã nguồn: người quản trị đọc "Xem bản ghi DNS" là đủ, `dns.view` chỉ làm rối.
 */

import { useT } from '../lib/i18n';
import type { ComparisonMatrix } from '../lib/types';

export function ComparisonTable({
  matrix,
  title,
  subtitle,
  odId,
}: {
  matrix: ComparisonMatrix;
  title: string;
  subtitle: string;
  odId: string;
}) {
  const t = useT();

  return (
    <div className="card mt-20" data-od-id={`${odId}-card`}>
      <div className="card-head">
        <div className="grow">
          <h2>{title}</h2>
          <div className="sub">{subtitle}</div>
        </div>
      </div>
      <div className="card-body" style={{ paddingTop: 0 }}>
        <div className="table-wrap">
          <table className="tbl" data-od-id={odId}>
            <thead>
              <tr>
                <th scope="col">{t('roles.capabilities')}</th>
                {matrix.roles.map((role) => (
                  <th scope="col" className="right" key={role.id}>
                    {role.name}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {matrix.capabilities.map((cap) => (
                <tr key={cap.id}>
                  <th scope="row" style={{ fontWeight: 500, textAlign: 'left' }}>
                    {cap.name}
                  </th>
                  {matrix.roles.map((role) => {
                    const has = role.capabilities.includes(cap.id);
                    return (
                      <td className="right" key={role.id}>
                        <span
                          className={has ? 'chip ok' : 'chip'}
                          style={has ? undefined : { opacity: 0.55 }}
                        >
                          {has ? t('common.yes') : t('common.no')}
                        </span>
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
